import connection from '../../../../api/config/connection'

export default {
  search: (input, callback, optionsSourceBaseUrl, optionsSourceLabelPrefix = 'Label') => {
    const options = {
      method: 'GET',
      url: `${optionsSourceBaseUrl}`,
      params: {
        text: input
      }
    }

    connection.instance()(options)
      .then((response) => {
        try {
          const options = (!response.data.result || !response.data.result.results || !response.data.result.results.stops) ? [] : response.data.result.results.stops.map(stop => {
            const {
              stopid,
              name,
              town,
            } = stop;
            return {
              label: `${optionsSourceLabelPrefix}: ${town}, ${name}`,
              value: {
                stopid: stopid,
                name,
                town
              }
            }
          })

          callback(options)
        } catch (ex) {
          console.error(ex);
          callback()
        }
      })
      .catch((response) => {
        callback()
      })
  },

  convertSelectValueToValue: (selectValue, callback) => {
    callback(selectValue.value)
  },

  convertValueToSelectValue: (value, optionsSourceLabelPrefix = 'Label') => {
    const selectValue = value ? {
      label: `${optionsSourceLabelPrefix}: ${value.town}, ${value.name}`,
      value: JSON.stringify(value)
    } : null

    return selectValue;
  },

  //components: {}
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/SelectSources/Halte.js